import { BaseModel } from '../../_base/crud';
import { Expose, Type } from 'class-transformer';

export class TFA extends BaseModel {
  @Expose()
  enabled: boolean;

  @Expose()
  secret: string;

  @Expose()
  tmpSecret: string;

  @Expose()
  dataURL: string;

  @Expose()
  tfaURL: string;

  clear(): void {
    this.enabled = false;
    this.secret = '';
    this.tmpSecret = '';
    this.dataURL = '';
    this.tfaURL = '';
  }
}
